
    (function () {
      function onPageShowEvents() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(initCartEvent, { timeout: 500 })
        } else {
          initCartEvent()
        }
        function initCartEvent(){
          window.fetch(window.theme.routes.cart + '.js')
          .then((response) => {
            if(!response.ok){
              throw {status: response.statusText};
            }
            return response.json();
          })
          .then((response) => {
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: {
                cart: response,
              },
              bubbles: true,
            }));
            return response;
          })
          .catch((e) => {
            console.error(e);
          });
        }
      };
      window.onpageshow = onPageShowEvents;
    })();
  
;
    (function () {
      function isCartMutationUrl(url) {
        if (typeof url !== 'string') { return false; }
        return url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1;
      }

      function refreshCartDrawer() {
        var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
        fetch(cartUrl + '.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart: cart },
              bubbles: true
            }));
            var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            }
          })
          .catch(function () {
            var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            }
          });
      }
      window.__grenadineRefreshCartDrawer = refreshCartDrawer;

      if (typeof window.fetch === 'function' && !window.__grenadineCartFetchWrapped) {
        var originalFetch = window.fetch;
        window.fetch = function (input, init) {
          var url = (typeof input === 'string') ? input : ((input && input.url) || '');
          var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
          var isAdd = isCartMutationUrl(url) && String(method).toUpperCase() === 'POST';
          var promise = originalFetch.apply(this, arguments);
          if (isAdd) {
            promise.then(function (response) {
              if (response && response.ok) {
                response.clone().json().then(function (data) {
                  if (!data || !data.status) {
                    refreshCartDrawer();
                  }
                }).catch(function () {
                  refreshCartDrawer();
                });
              }
              return response;
            }).catch(function () {});
          }
          return promise;
        };
        window.__grenadineCartFetchWrapped = true;
      }

      if (window.XMLHttpRequest && !window.__grenadineCartXhrWrapped) {
        var OriginalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
          this.__grenadineIsCartAdd = isCartMutationUrl(url) && String(method).toUpperCase() === 'POST';
          return OriginalOpen.apply(this, arguments);
        };
        var OriginalSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
          if (this.__grenadineIsCartAdd) {
            this.addEventListener('load', function () {
              if (this.status >= 200 && this.status < 300) {
                try {
                  var data = JSON.parse(this.responseText);
                  if (!data || !data.status) {
                    refreshCartDrawer();
                  }
                } catch (e) {
                  refreshCartDrawer();
                }
              }
            });
          }
          return OriginalSend.apply(this, arguments);
        };
        window.__grenadineCartXhrWrapped = true;
      }
    })();
  